import { atom } from "jotai";
import { State } from "./State";
import { fetchBase } from "./BaseApi";

export type Ranking = {
  contentType: string;
  contentId: string;
  title: string;
  summary: string;
  tag: string;
  imageData: string;
  externalUrl: string;
  internalUrl: string;
  isChallenged: boolean;
  totalCorrectNumber: number;
  expectedTime?: number;
};

const uri = "api/ranking";

export const fetchRankingAtom = atom<State<Ranking> | null>(null);
export const fetchRanking = () => {
  return fetchBase<Ranking>(uri, fetchRankingAtom);
};
